// Similarité de symptôme locale par trigrammes — équivalent navigateur de la
// fonction similarity() de pg_trgm utilisée côté core. Garantit que le résultat
// hors-ligne est cohérent avec le résultat en ligne.

function trigrams(text: string): Set<string> {
  // Normalisation proche de pg_trgm : minuscules, non-alphanum → espace,
  // padding par deux espaces en tête et un en queue de chaque mot.
  const cleaned = text
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "") // enlève les accents
    .replace(/[^a-z0-9]+/g, " ")
    .trim();
  const grams = new Set<string>();
  for (const word of cleaned.split(/\s+/).filter(Boolean)) {
    const padded = `  ${word} `;
    for (let i = 0; i < padded.length - 2; i++) grams.add(padded.slice(i, i + 3));
  }
  return grams;
}

/** Similarité 0..1 (intersection / union des trigrammes). */
export function similarity(a: string, b: string): number {
  const A = trigrams(a);
  const B = trigrams(b);
  if (A.size === 0 || B.size === 0) return 0;
  let inter = 0;
  for (const g of A) if (B.has(g)) inter++;
  const union = A.size + B.size - inter;
  return union === 0 ? 0 : inter / union;
}
